import {CasinoLegacyDeepLinkActionBase} from '../casino-legacy-deep-link-action-base';
import {CashierDeepLinkAction} from "../cashier/cashier-deeplink-action";
import {IRegisterActionData} from "@sparkware/uc-sdk-core";

export class RegisterDeepLinkAction extends CasinoLegacyDeepLinkActionBase {

  private _findCashierActionAndSkipAllSubsequentActions(): CashierDeepLinkAction | null {
    let nextAction = this.nextAction;
    let cashierAction: CashierDeepLinkAction | null = null;
    while (nextAction) {
      if(nextAction instanceof CashierDeepLinkAction) {
        cashierAction = nextAction;
      }

      nextAction.skipAction();
      nextAction = nextAction.nextAction;
    }

    return cashierAction;
  }

  async execute(): Promise<void> {

    const cashierDeepLinkAction = this._findCashierActionAndSkipAllSubsequentActions();

    let cashierSpecificParams: IRegisterActionData = {};
    if(cashierDeepLinkAction) {
      const params = cashierDeepLinkAction.getCashierSpecificParameters();
      if(params?.promoCode) {
        cashierSpecificParams = {
          promoCode: params.promoCode
        }
      }
      cashierDeepLinkAction.skipAction();
    }

    if(this.descriptor.promoCode) {
      cashierSpecificParams.promoCode = this.descriptor.promoCode;
    }

    await this.services.messageBroker.channels.performAction.topics.register.execute({
      actionData: {
        ...this.descriptor.marketingParams,
        ...cashierSpecificParams
      }
    });
    await this._executeNextAction();
  }
}
